module.exports = __webpack_public_path__ + "media/components/eligibilityQuestions/icons/close-5f620623a1989a8ed676c64a6d56898a.svg";